// Centralized Tours-related UI constants

// These hex values intentionally mirror existing design tokens in
// `src/styles/_variables.scss` (Sass variables are not directly importable in TS).
export const TOUR_AGENT_COLOR_HEXES: readonly string[] = [
  '#7650e0', // $secondary-color
  '#00A889', // $primary-color
  '#425CAA', // $deep-blue
  '#EA8D3A', // $fire-flame
  '#0B64E0', // $vibrant-blue
  '#50bf7a', // $success
  '#00B8F5', // $neon-blue
  '#D50159', // $cherry-red
  '#9E5C00', // $mustard-yellow
  '#006AA3', // $dusty-blue
] as const;

// Matches $dusty-blue-light in `src/styles/_variables.scss`.
export const TOUR_AVAILABILITY_EVENT_BG_HEX = '#E6F3FA' as const;

// Per-status colours for tour calendar events, keyed by `followUpStatus`.
export const TOUR_CALENDAR_STATUS_COLOR_HEXES: Readonly<Record<string, { background: string, border: string }>> = {
  requested: { background: '#E0EAFF', border: '#2E82FF' }, // $info-light / $info-dark
  confirmed: { background: '#DCEFE3', border: '#37955B' }, // $success-light / $success-dark
  cancel: { background: '#FFE7E0', border: '#ED4A60' }, // $error-light / $error-dark
  'tour-completed': { background: '#F1EEFC', border: '#7650E0' }, // $secondary-light / $secondary-color
  closed: { background: '#FFEBCC', border: '#B87A00' }, // $warning-light / $warning-dark
} as const;
